import React from 'react';
import SpendingsList from '../features/transactions/SpendingsList';

const SpendingsPage: React.FC<{ startDate: string | null, endDate: string | null, schoolYear: string }> = ({ startDate, endDate, schoolYear }) => {
    return (
        <div className="page">
            <SpendingsList startDate={startDate} endDate={endDate} schoolYear={schoolYear} />
        </div>
    );
};

export default SpendingsPage;
